import { createFileRoute } from '@tanstack/react-router'
import { ShieldAlertIcon } from 'lucide-react'
import { Admin } from '@/components/auth/admin/admin'
import { permissionsFor } from '../../../shared/permissions'

export const Route = createFileRoute('/_authed/staff')({ component: Staff })

function Staff() {
	const { user } = Route.useRouteContext()

	return (
		<>
			{/* Global admins and service admins (`<service>:admin`) may list staff; the dialog offers each only what they may change. */}
			{permissionsFor(user.role).user?.includes('list') ? (
				<Admin view="users" hideNav />
			) : (
				<div className="flex min-h-64 flex-col items-center justify-center gap-3 rounded-xl border border-dashed bg-card p-8 text-center">
					<ShieldAlertIcon className="size-8 text-primary" />
					<h2 className="font-semibold">Admins only</h2>
					<p className="max-w-md text-sm text-muted-foreground">
						You need the admin role, or the admin role of a service such as <code className="rounded bg-muted px-1.5 py-0.5 text-xs">standards:admin</code>.
						Ask an admin to grant it, or run <code className="rounded bg-muted px-1.5 py-0.5 text-xs">bun run make-admin {user.email}</code>.
					</p>
				</div>
			)}
		</>
	)
}
